export const RESET = 'EXCMDEVICEMODEL_LIST_RESET'
export const SET_ITEMS = 'EXCMDEVICEMODEL_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDEVICEMODEL_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDEVICEMODEL_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDEVICEMODEL_LIST_TOGGLE_LOADING'
